var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "43.907",
        height: "44.867",
        viewBox: "5.207 0 43.907 44.867",
      },
    },
    [
      _c("g", { attrs: { "data-name": "XMLID_1812_" } }, [
        _c("path", {
          attrs: {
            d: "m6.579 13.13 2.066.969a14.759 14.759 0 0 0-.277 6.04l-2.14.775a1.564 1.564 0 0 0-.931 1.992l.82 2.25a1.564 1.564 0 0 0 1.993.932l2.14-.774a14.68 14.68 0 0 0 4.085 4.454l-.968 2.066a1.561 1.561 0 0 0 .747 2.066l2.176 1.014c.775.36 1.697.028 2.066-.747l.968-2.075c1.43.36 2.924.517 4.436.424l.028-.6a3.152 3.152 0 0 1 1.033-2.203 3.126 3.126 0 0 1 2.047-.83c.13-.323.277-.637.443-.95a3.065 3.065 0 0 1-.47-.849c-.84.342-1.734.581-2.675.692-5.524.646-10.523-3.302-11.168-8.826-.646-5.524 3.301-10.523 8.826-11.168 5.524-.646 10.523 3.301 11.168 8.826a9.982 9.982 0 0 1-.867 5.404c.36.147.683.36.969.627.322-.13.645-.249.986-.36a3.179 3.179 0 0 1 3.293-2.794l.221.01c.157-1.338.13-2.703-.092-4.068l2.232-.812a1.564 1.564 0 0 0 .931-1.992l-.82-2.25a1.564 1.564 0 0 0-1.992-.931l-2.232.811a14.553 14.553 0 0 0-4.03-4.408l1.005-2.14a1.561 1.561 0 0 0-.747-2.066L29.672.625a1.561 1.561 0 0 0-2.066.747l-.996 2.13a14.659 14.659 0 0 0-5.985-.286l-.793-2.195A1.564 1.564 0 0 0 17.84.09l-2.25.82a1.564 1.564 0 0 0-.932 1.993l.793 2.176a14.673 14.673 0 0 0-4.455 4.049L8.921 8.16a1.561 1.561 0 0 0-2.065.747L5.84 11.083c-.378.756-.046 1.679.738 2.048Z",
            fill: _vm.color || "#ec4b1d",
            "fill-rule": "evenodd",
            "data-name": "XMLID_1906_",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M39.706 22.759v-.046a.981.981 0 0 0-.931-.978l-1.513-.064a.98.98 0 0 0-1.023.931l-.065 1.439a9.302 9.302 0 0 0-3.578 1.291l-.969-1.06a.987.987 0 0 0-1.383-.065l-1.116 1.024a.973.973 0 0 0-.314.719c0 .24.083.47.259.664l.968 1.06a9.212 9.212 0 0 0-1.605 3.45l-1.438-.065a.98.98 0 0 0-1.024.932l-.065 1.512v.046c0 .517.406.95.932.978l1.448.064a9.2 9.2 0 0 0 1.31 3.56l-1.08.987a.973.973 0 0 0-.313.72c0 .24.083.47.258.664l1.024 1.115a.987.987 0 0 0 1.383.065l1.088-.996a9.304 9.304 0 0 0 3.431 1.586l-.064 1.485v.046c0 .517.405.95.931.978l1.512.064a.98.98 0 0 0 1.024-.931l.065-1.485a9.097 9.097 0 0 0 3.532-1.291l1.005 1.107a.987.987 0 0 0 1.384.064l1.116-1.024a.973.973 0 0 0 .313-.719c0-.24-.083-.47-.258-.664l-1.005-1.107a9.177 9.177 0 0 0 1.595-3.412l1.485.065a.98.98 0 0 0 1.024-.932l.064-1.512v-.046a.981.981 0 0 0-.931-.978l-1.485-.065a9.162 9.162 0 0 0-1.282-3.55l1.088-.996a.973.973 0 0 0 .314-.72c0-.24-.083-.47-.258-.664l-1.024-1.116a.987.987 0 0 0-1.384-.064l-1.079.987a9.22 9.22 0 0 0-3.43-1.614l.064-1.44Zm1.522 7.11a5.02 5.02 0 0 1 1.319 3.404c0 1.365-.554 2.73-1.642 3.716a5.042 5.042 0 0 1-7.12-.313 5.02 5.02 0 0 1-1.318-3.403c0-1.365.553-2.73 1.641-3.717a5.034 5.034 0 0 1 7.12.314Z",
            fill: _vm.color || "#ec4b1d",
            "fill-rule": "evenodd",
            "data-name": "XMLID_1868_",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M22.977 10.3a7.474 7.474 0 0 0-7.47 7.47 7.474 7.474 0 0 0 7.47 7.47 7.474 7.474 0 0 0 7.47-7.47 7.474 7.474 0 0 0-7.47-7.47Zm0 5.035a2.432 2.432 0 0 0-2.435 2.435c0 .617-.498 1.115-1.116 1.115a1.114 1.114 0 0 1-1.116-1.115 4.672 4.672 0 0 1 4.667-4.667c.617 0 1.115.498 1.115 1.116a1.12 1.12 0 0 1-1.115 1.116Z",
            fill: _vm.color || "#ec4b1d",
            "fill-rule": "evenodd",
            "data-name": "XMLID_1827_",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }